const form = document.getElementById('contact-form');

form.addEventListener('submit', function (e) {
    // Remove ?success=1 from URL if present
    if (window.location.search.includes('success=1')) {
        history.replaceState(null, '', window.location.pathname + '#contact-form');
    }

    let valid = true;

    // Clear previous errors
    form.querySelectorAll('.field-error').forEach(el => el.remove());
    form.querySelectorAll('.input-error').forEach(el => el.classList.remove('input-error'));

    const name = form.querySelector('#name');
    const email = form.querySelector('#email');
    const tnc = form.querySelector('#tnc');

    if (!name.value.trim()) {
        showError(name.closest('div').parentElement, 'Bitte gib deinen Namen ein.');
        valid = false;
    }

    if (!email.value.trim()) {
        showError(email.closest('div').parentElement, 'Bitte gib deine Email-Adresse ein.');
        valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
        showError(email.closest('div').parentElement, 'Bitte gib eine gültige E-Mail-Adresse ein.');
        valid = false;
    }
    if (!tnc.checked) {
        showError(tnc.closest('label'), 'Bitte akzeptiere die Datenschutzerklärung.');
        valid = false;
    }

    if (!valid) {
        e.preventDefault();
        document.getElementById('form-success')?.remove();
    }
});

function showError(anchor, message) {
    if (anchor.tagName === 'INPUT') anchor.classList.add('input-error');
    const msg = document.createElement('p');
    msg.className = 'field-error text-red-400 text-sm mb-4';
    msg.textContent = message;
    anchor.after(msg);
}
